import React from "react";

const ExpertEditing = () => {
  return (
    <>
      <section className="main-expert-editin-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="exp-heading">
                <h2>
                  Expert Editing Services for Several Subject-Matters and
                  Backgrounds!
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="testi_box testiText">
                <h3>Law And Legal Studies</h3>
                <p>
                  Our organization provides best editing services to law
                  students based on following modules:
                </p>
                <ul className="test-list">
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="testi_box testiText">
                <h3>Law And Legal Studies</h3>
                <p>
                  Our organization provides best editing services to law
                  students based on following modules:
                </p>
                <ul className="test-list">
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="testi_box testiText">
                <h3>Nursing And Medicines</h3>
                <p>
                  We provide finest editing services with the specialized
                  experts of nursing and medicines based on following modules:
                </p>
                <ul className="test-list">
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="testi_box testiText">
                <h3>Education</h3>
                <p>
                  Our organization provide quality editing services to students
                  based on following modules:
                </p>
                <ul className="test-list">
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="testi_box testiText">
                <h3>Law And Legal Studies</h3>
                <p>
                  Our organization provides best editing services to law
                  students based on following modules:
                </p>
                <ul className="test-list">
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="testi_box testiText">
                <h3>Health Science &amp; Occupation Safety:</h3>
                <p>
                  We provide quality editing services to students based on
                  following modules:
                </p>
                <ul className="test-list">
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                  <li className="test-list-li">
                    <i className="fa fa-check" aria-hidden="true" />
                    Result
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExpertEditing;
